// Constantes compartilhadas de consentimento de cookies.
//
// IMPORTANTE: este módulo NÃO pode ser marcado com 'use client'. Ele é importado
// tanto por componentes de cliente (consent-context.tsx) quanto por componentes
// de servidor (app/_gtm.tsx — script de Consent Mode no <head>). Se as constantes
// fossem exportadas de um módulo 'use client', o Next as substituiria por
// client-reference proxies ao serem usadas no servidor, e a interpolação no
// template literal do script geraria uma função que lança erro em vez do valor.

export const STORAGE_KEY = 'ccp:cookie-consent';
export const STORAGE_VERSION = 1;

// Incrementar quando o Aviso de Privacidade for atualizado de forma material —
// invalida consentimentos anteriores e força o banner a reaparecer.
export const POLICY_VERSION = 1;

// Tempo máximo que uma escolha permanece válida antes de pedir de novo.
const CONSENT_EXPIRY_DAYS = 90;
export const CONSENT_EXPIRY_MS = CONSENT_EXPIRY_DAYS * 24 * 60 * 60 * 1000;
